import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { PaymentMigrationConfigStore, PaymentMigrationStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import InPlaceText from 'components/form/in_place_text';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import DashboardCount from 'pages/builder/dashboard/dashboard_count';
import React from 'react';
import { Link } from 'react-router';
import Paginator from 'components/paginator';
import Text from 'components/text';
import Stack from 'components/layout/stack';
import { flexCenter } from '@seedlang/style_mixins';
import PageTitle from 'components/common/page_title';

const Wrapper = styled.div`

`;

const Title = styled.div`
  background: #FFF;
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  margin: ${props => props.margin || '20px 0 10px 0'};
`;

const DashboardCountStack = styled(Stack)`
  margin-bottom: 20px;
  .dashboard-count {
    width: 100%;
    margin: 0;

    .dashboard-count-label {
      ${flexCenter()}
      min-height: 50px;
      padding: 5px;
    }
  }
`;

@observer
class PaymentMigrationIndex extends React.Component {
  @observable stats = null;

  constructor(props) {
    super(props);
    this.loadStats();
    this.loadConfig();
    this.loadPendingPaymentMigrations();
  }

  @autobind loadStats() {
    AppUI.api.ajax({
      method: 'GET',
      url: '/api/payment_migration_stats',
      successCallback: resp => {
        this.stats = resp;
      },
    });
  }

  @autobind loadConfig() {
    PaymentMigrationConfigStore.getShow();
  }

  @autobind loadPendingPaymentMigrations() {
    PaymentMigrationStore.getIndex({ filters: { pending: true }});
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Payment Migration</PageTitle>
        <Title
          margin='0 0 20px 0'
        >
          Statistics
        </Title>

        <DashboardCountStack inline gap='sm'>
          <DashboardCount
            label='Setting up'
            count={this.stats?.settingUp}
          />
          <DashboardCount
            label='Stripe Payment setup started'
            count={this.stats?.stripePaymentSetupStarted}
          />
          <DashboardCount
            label='Waiting for Patreon cancellation'
            count={this.stats?.waitingForPatreonCancellation}
          />
          <DashboardCount
            label='Waiting for Patreon expiry'
            count={this.stats?.waitingForPatreonExpiry}
          />
          <DashboardCount
            label='Completed'
            count={this.stats?.completed}
          />
        </DashboardCountStack>
        <Title
          margin='20px 0 5px 0'
        >
          Info Link
        </Title>
        <Text>This url will be linked as a help resource during the migration process.</Text>
        <InPlaceText
          show
          defaultValue={PaymentMigrationConfigStore.showData.infoUrl}
          model='payment_migration_config'
          field='info_url'
          id={PaymentMigrationConfigStore.showData.id}
        />
        <Title
          margin='20px 0 20px 0'
        >
          Pending Migrations
        </Title>

        <table
          className='table-wrapper'
          style={{
            marginTop: 10,
          }}
        >
          <thead>
            <tr>
              <th width='40'></th>
              <th>Email</th>
              <th>Status</th>
              <th># Mnths</th>
              <th>Created</th>
              <th colSpan='2'>Payment Method Added</th>
              <th colSpan='2'>Patreon Expires</th>
            </tr>
          </thead>
          <tbody>
            {
              PaymentMigrationStore.indexData.map(item => (
                <tr key={item.id}>
                  <td>
                    {
                      item.user &&
                      <Link
                        to={{
                          name: 'creator.users.edit',
                          params: { userId: item.user?.id},
                        }}
                        className='on-click'
                      >
                        <i className='fa fa-chevron-right fa-block'/>
                      </Link>
                    }
                  </td>
                  <td>
                    {item.user?.email}
                  </td>
                  <td>
                    {item.friendlyStatus}
                  </td>
                  <td>
                    {item.membership?.numberMonths}
                  </td>
                  <td>
                    <span title={item.createdAt.formattedDateWithYearAndTime}>{item.createdAt.formattedDate}</span>
                  </td>
                  <td>
                    <span title={item.paymentMethodAddedAt.formattedDateWithYearAndTime}>{item.paymentMethodAddedAt.formattedDate}</span>
                  </td>
                  <td>
                    ({item.paymentMethodAddedAt.relativeDays})
                  </td>
                  <td>
                    <span title={item.patreonMembershipExpiresAt.formattedDateWithYearAndTime}>{item.patreonMembershipExpiresAt.formattedDate}</span>
                  </td>
                  <td>
                    ({item.patreonMembershipExpiresAt.relativeDays})
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
        <Paginator
          store={PaymentMigrationStore}
        />
      </Wrapper>
    );
  }
}

export default ErrorBoundary(PaymentMigrationIndex);
